import { trackSponsorClick } from "../lib/analytics";
import React, { useEffect, useState } from "react";
import { listSponsors } from "../lib/db";

export default function SponsorStrip() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    listSponsors()
      .then((data) => setSponsors(data.filter((s) => s.tier === "oro" || s.tier === "argento")))
      .catch(console.error);
  }, []);

  if (sponsors.length === 0) return null;

  const renderLogo = (s, keyPrefix) => (
    <a
      key={`${keyPrefix}-${s.id}`}
      href={s.website_url || "#"}
      target="_blank"
      rel="noopener noreferrer"
      title={s.name}
      onClick={() => trackSponsorClick(s.name, s.tier)}
      className="shrink-0 mx-6 flex items-center transition-transform duration-200 hover:scale-110"
    >
      {s.logo_url ? (
        <img
          src={s.logo_url}
          alt={s.name}
          className={`w-auto object-contain opacity-80 hover:opacity-100 transition-opacity ${
            s.tier === "oro" ? "h-16" : "h-12"
          }`}
        />
      ) : (
        <span
          className={`font-display font-bold text-zinc-400 hover:text-yellow-400 transition-colors whitespace-nowrap ${
            s.tier === "oro" ? "text-base" : "text-sm"
          }`}
        >
          {s.name}
        </span>
      )}
    </a>
  );

  return (
    <div className="w-full bg-zinc-900 border-b border-zinc-800 py-2 overflow-hidden group">
      <div className="flex w-max animate-sponsor-scroll group-hover:[animation-play-state:paused]">
        {sponsors.map((s) => renderLogo(s, "a"))}
        {sponsors.map((s) => renderLogo(s, "b"))}
      </div>
    </div>
  );
}